import { APP_LOADING } from 'vx/mutations'
import store from 'vx/store'

export default (to, from, next) => {
  window.paceOptions = {
    startOnPageLoad: false,
    restartOnPushState: true,
    restartOnRequestAfter: false,
    ajax: {
      trackWebSockets: false
    }
  }

  const pace = require('pace-progress')

  store.commit(`app/${APP_LOADING}`, true)

  pace.once('hide', () => store.commit(`app/${APP_LOADING}`, false))

  pace.start()

  next()
}



// WEBPACK FOOTER //
// ./src/router/before/pace.js